export enum DocumentEnum {
	CPF = 'CPF',
	CNPJ = 'CNPJ',
}
